import { PreviewPBLPage } from '@hendrx/core/pbl/pages/PreviewPBLPage';
import { createFileRoute } from '@tanstack/react-router';

import { useResponsiveRootFontSize } from 'shared/utils/useResponsiveRootFontSize';

export const Route = createFileRoute('/studio/pbl/preview/$pblDraftId')({
  component: PreviewPBLPageComponent
});

function PreviewPBLPageComponent() {
  useResponsiveRootFontSize({ minFontSize: 8 });

  const { pblDraftId } = Route.useParams();

  return <PreviewPBLPage pblDraftId={pblDraftId} />;
}
